import { siteConfig } from '../config';

export function ContactPage() {
  return (
    <section className="section container contact page-intro page-sheet">
      <p className="eyebrow">Contact</p>
      <h1 className="page-intro__title">Ready when you are</h1>
      <p className="contact__text">
        To reach {siteConfig.brandName}, use the{' '}
        <strong>green chat button</strong> in the upper right corner and make an online presence more stronger than ever.
      </p>
    </section>
  );
}
